import styled from '@emotion/styled'

export const QuotesPeriodSelector = styled.div`
  margin-left: auto;
`
